@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import org.zest.insan_360_website.components.layouts.AssessmentPageLayout as _org_zest_insan_360_website_components_layouts_AssessmentPageLayout
import org.zest.insan_360_website.components.layouts.MainPageLayout as _org_zest_insan_360_website_components_layouts_MainPageLayout
import org.zest.insan_360_website.components.layouts.ResultPageLayout as _org_zest_insan_360_website_components_layouts_ResultPageLayout
import org.zest.insan_360_website.components.layouts.UserDashboardLayout as _org_zest_insan_360_website_components_layouts_UserDashboardLayout
import org.zest.insan_360_website.pages.AssessmentPage as _org_zest_insan_360_website_pages_AssessmentPage
import org.zest.insan_360_website.pages.ForgotPasswordPage as _org_zest_insan_360_website_pages_ForgotPasswordPage
import org.zest.insan_360_website.pages.LoginPage as _org_zest_insan_360_website_pages_LoginPage
import org.zest.insan_360_website.pages.PaymentStatusPage as _org_zest_insan_360_website_pages_PaymentStatusPage
import org.zest.insan_360_website.pages.RegisterPage as _org_zest_insan_360_website_pages_RegisterPage
import org.zest.insan_360_website.pages.ResetPasswordPage as _org_zest_insan_360_website_pages_ResetPasswordPage
import org.zest.insan_360_website.pages.ResultPage as _org_zest_insan_360_website_pages_ResultPage
import org.zest.insan_360_website.pages.user.AdminsPage as _org_zest_insan_360_website_pages_user_AdminsPage
import org.zest.insan_360_website.pages.user.CoachAssistantPage as _org_zest_insan_360_website_pages_user_CoachAssistantPage
import org.zest.insan_360_website.pages.user.CreditsPage as _org_zest_insan_360_website_pages_user_CreditsPage
import org.zest.insan_360_website.pages.user.LifeCoachPage as _org_zest_insan_360_website_pages_user_LifeCoachPage
import org.zest.insan_360_website.pages.user.StudentsPage as _org_zest_insan_360_website_pages_user_StudentsPage
import org.zest.insan_360_website.pages.user.UserMainPage as _org_zest_insan_360_website_pages_user_UserMainPage
import org.zest.insan_360_website.pages.user.UserReportPage as _org_zest_insan_360_website_pages_user_UserReportPage
import org.zest.insan_360_website.pages.user.UserSettingsPage as _org_zest_insan_360_website_pages_user_UserSettingsPage
import org.zest.insan_360_website.pages.user.UserSupportPage as _org_zest_insan_360_website_pages_user_UserSupportPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Profile Analysis"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "org.zest.insan_360_website.components.layouts.AssessmentPageLayout",
        ) { pageCtx, pageMethod -> 
            _org_zest_insan_360_website_components_layouts_AssessmentPageLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "org.zest.insan_360_website.components.layouts.MainPageLayout",
        ) { pageCtx, pageMethod -> 
            _org_zest_insan_360_website_components_layouts_MainPageLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "org.zest.insan_360_website.components.layouts.ResultPageLayout",
        ) { pageCtx, pageMethod -> 
            _org_zest_insan_360_website_components_layouts_ResultPageLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "org.zest.insan_360_website.components.layouts.UserDashboardLayout",
        ) { pageCtx, pageMethod -> 
            _org_zest_insan_360_website_components_layouts_UserDashboardLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "org.zest.insan_360_website.components.layouts.MainPageLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_LoginPage(pageCtx)
        }
        ctx.router.register(
            "/assessment",
            layoutId = "org.zest.insan_360_website.components.layouts.AssessmentPageLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_AssessmentPage(pageCtx)
        }
        ctx.router.register(
            "/forgot-password",
            layoutId = "org.zest.insan_360_website.components.layouts.MainPageLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_ForgotPasswordPage()
        }
        ctx.router.register(
            "/payment-status",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_PaymentStatusPage(pageCtx)
        }
        ctx.router.register(
            "/register",
            layoutId = "org.zest.insan_360_website.components.layouts.MainPageLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_RegisterPage()
        }
        ctx.router.register(
            "/reset-password",
            layoutId = "org.zest.insan_360_website.components.layouts.MainPageLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_ResetPasswordPage()
        }
        ctx.router.register(
            "/result",
            layoutId = "org.zest.insan_360_website.components.layouts.ResultPageLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_ResultPage(pageCtx)
        }
        ctx.router.register(
            "/user/",
            layoutId = "org.zest.insan_360_website.components.layouts.UserDashboardLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_user_UserMainPage(pageCtx)
        }
        ctx.router.register(
            "/user/admins",
            layoutId = "org.zest.insan_360_website.components.layouts.UserDashboardLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_user_AdminsPage(pageCtx)
        }
        ctx.router.register(
            "/user/coach-assistant",
            layoutId = "org.zest.insan_360_website.components.layouts.UserDashboardLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_user_CoachAssistantPage(pageCtx)
        }
        ctx.router.register(
            "/user/credits",
            layoutId = "org.zest.insan_360_website.components.layouts.UserDashboardLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_user_CreditsPage(pageCtx)
        }
        ctx.router.register(
            "/user/life-coach",
            layoutId = "org.zest.insan_360_website.components.layouts.UserDashboardLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_user_LifeCoachPage(pageCtx)
        }
        ctx.router.register(
            "/user/report",
            layoutId = "org.zest.insan_360_website.components.layouts.UserDashboardLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_user_UserReportPage()
        }
        ctx.router.register(
            "/user/settings",
            layoutId = "org.zest.insan_360_website.components.layouts.UserDashboardLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_user_UserSettingsPage()
        }
        ctx.router.register(
            "/user/students",
            layoutId = "org.zest.insan_360_website.components.layouts.UserDashboardLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_user_StudentsPage(pageCtx)
        }
        ctx.router.register(
            "/user/support",
            layoutId = "org.zest.insan_360_website.components.layouts.UserDashboardLayout",
        ) { pageCtx -> 
            _org_zest_insan_360_website_pages_user_UserSupportPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("assessment-page-content", org.zest.insan_360_website.components.layouts.AssessmentPageContentStyle)
        ctx.theme.registerStyle("base-input", org.zest.insan_360_website.components.layouts.baseInputStyle)
        ctx.theme.registerStyle("button-color", org.zest.insan_360_website.components.layouts.buttonColorStyle)
        ctx.theme.registerStyle("font-size-breakpoints", org.zest.insan_360_website.components.layouts.fontSizeBreakpoints)
        ctx.theme.registerStyle("standalone-container", org.zest.insan_360_website.components.layouts.standaloneContainerStyle)
        ctx.theme.registerStyle("base-dashboard-grid-style_1", org.zest.insan_360_website.components.layouts.BaseDashboardGridStyle_1)
        ctx.theme.registerStyle("dashboard-layout", org.zest.insan_360_website.components.layouts.dashboardLayout)
        ctx.theme.registerStyle("content-box", org.zest.insan_360_website.components.layouts.contentBoxStyle)
        ctx.theme.registerStyle("dashboard-nav-element", org.zest.insan_360_website.components.layouts.dashboardNavElementStyle)
        ctx.theme.registerStyle("disabled-content-button", org.zest.insan_360_website.components.layouts.disabledContentButtonStyle)
        ctx.theme.registerStyle("content-button", org.zest.insan_360_website.components.layouts.contentButtonStyle)
        ctx.theme.registerStyle("neutral-content-button", org.zest.insan_360_website.components.layouts.neutralContentButtonStyle)
        ctx.theme.registerStyle("content-red-button", org.zest.insan_360_website.components.layouts.contentRedButtonStyle)
        ctx.theme.registerStyle("content-button-text", org.zest.insan_360_website.components.layouts.contentButtonTextStyle)
        ctx.theme.registerStyle("profile-list-content-layout", org.zest.insan_360_website.components.layouts.profileListContentLayout)
        ctx.theme.registerStyle("container-shadow", org.zest.insan_360_website.components.layouts.containerShadowStyle)
        ctx.theme.registerStyle("modal", org.zest.insan_360_website.components.widgets.modalStyle)
        ctx.theme.registerStyle("toggle-size-breakpoints", org.zest.insan_360_website.components.widgets.toggleSizeBreakpoints)
        ctx.theme.registerStyle("question-cell", org.zest.insan_360_website.components.widgets.QuestionCellStyle)
        ctx.theme.registerStyle("question-cell-grid", org.zest.insan_360_website.components.widgets.QuestionCellGridStyle)
        ctx.theme.registerStyle("more-or-less-button", org.zest.insan_360_website.components.widgets.moreOrLessButtonStyle)
        ctx.theme.registerStyle("index-button", org.zest.insan_360_website.components.widgets.IndexButtonStyle)
        ctx.theme.registerStyle("question-index-selection", org.zest.insan_360_website.components.widgets.QuestionIndexSelectionStyle)
        ctx.theme.registerStyle("question-index-container", org.zest.insan_360_website.components.widgets.QuestionIndexContainerStyle)
        ctx.theme.registerStyle("modal-button-container", org.zest.insan_360_website.components.widgets.modalButtonContainerStyle)
        ctx.theme.registerStyle("modal-button", org.zest.insan_360_website.components.widgets.modalButtonStyle)
        ctx.theme.registerStyle("button", org.zest.insan_360_website.pages.ButtonStyle)
        ctx.theme.registerStyle("page-column", org.zest.insan_360_website.pages.PageColumnStyle)
        ctx.theme.registerStyle("container", org.zest.insan_360_website.pages.containerStyle)
        ctx.theme.registerStyle("register-tab-text", org.zest.insan_360_website.pages.RegisterTabTextStyle)
        ctx.theme.registerStyle("sup-adm-dash-content-layout", org.zest.insan_360_website.pages.user.admins_layout.supAdmDashContentLayout)
        ctx.theme.registerStyle("sup-adm-container-grid", org.zest.insan_360_website.pages.user.admins_layout.supAdmContainerGrid)
        ctx.theme.registerStyle("admin-info", org.zest.insan_360_website.pages.user.admins_layout.adminInfoStyle)
        ctx.theme.registerStyle("content-background-icon", org.zest.insan_360_website.pages.user.contentBackgroundIconStyle)
        ctx.theme.registerStyle("admin-main-dash-content-layout", org.zest.insan_360_website.pages.user.main_layout.adminMainDashContentLayout)
        ctx.theme.registerStyle("stud-main-dash-content-layout", org.zest.insan_360_website.pages.user.main_layout.studMainDashContentLayout)
        ctx.theme.registerStyle("sup-adm-main-dash-content-layout", org.zest.insan_360_website.pages.user.main_layout.supAdmMainDashContentLayout)
        ctx.theme.registerStyle("report-section-button", org.zest.insan_360_website.pages.user.reportSectionButtonStyle)
        ctx.theme.registerStyle("settings-content-layout", org.zest.insan_360_website.pages.user.settingsContentLayout)
        ctx.theme.registerKeyframes("loading-dot", org.zest.insan_360_website.components.widgets.loadingDotAnimation)
        ctx.theme.registerKeyframes("spin", org.zest.insan_360_website.components.widgets.SpinAnimation)
        ctx.theme.registerKeyframes("fade-in-slide", org.zest.insan_360_website.pages.FadeInSlideKeyframes)
        ctx.theme.registerKeyframes("right-angle-movement", org.zest.insan_360_website.pages.RightAngleMovementKeyframes)
        ctx.theme.registerKeyframes("left-angle-movement", org.zest.insan_360_website.pages.LeftAngleMovementKeyframes)
        ctx.theme.registerKeyframes("to-left32-px", org.zest.insan_360_website.pages.toLeft32Px)
        ctx.theme.registerKeyframes("to-right32-px", org.zest.insan_360_website.pages.toRight32Px)
        org.zest.insan_360_website.initStyles(ctx)
        org.zest.insan_360_website.initFonts(ctx)
        org.zest.insan_360_website.initScrollbarStyle(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        org.zest.insan_360_website.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
